export default {
    title: "Historial de importaciones",
    subtitle: "Sigue las importaciones de pedidos y clientes de tu establecimiento.",
    cancelConfirmTitle: "¿Cancelar importación?",
    cancelConfirmBody: "La importación se detendrá. Los elementos ya procesados se mantendrán.",
    detailsTitle: "Detalles de la importación",
    close: "Cerrar",
    details: "Detalles",
    cancel: "Cancelar",
    preparing: "Preparando...",
    downloadFailed: "Descargar filas con error",
    columnType: "Tipo",
    columnFilename: "Archivo",
    columnUser: "Usuario",
    columnBranch: "Sucursal",
    columnStatus: "Estado",
    columnProgress: "Progreso",
    columnResults: "Resultados",
    columnDate: "Fecha",
    columnActions: "Acciones",
    columnError: "Error",
    columnPlugin: "Integración",
    columnImporter: "Importador",
    noData: "Sin datos calculados",
    summaryNewOrders: "Nuevos pedidos",
    summaryUpdatedOrders: "Pedidos actualizados",
    summaryNewClients: "Nuevos clientes",
    summaryUpdatedClients: "Clientes actualizados",
    summaryImportedOrders: "Pedidos importados",
    summaryFailed: "Filas con error",
    filterType: "Tipo",
    filterStatus: "Estado",
    filterPeriod: "Período",
    filterDateFrom: "Desde",
    filterDateTo: "Hasta",
    filterAll: "Todos",
    typeOrders: "Pedidos (planilla)",
    typeClients: "Clientes (planilla)",
    typePluginFile: "Archivo de integración",
    typePluginHistory: "Historial de la integración",
    ordersShort: "Pedidos",
    clientsShort: "Clientes",
    failedShort: "Errores",
    cancelSuccess: "Importación cancelada",
    cancelError: "Error al cancelar la importación",
    importData: "Importar datos",
    chooserTitle: "Importar datos",
    chooserSubtitle: "Elige qué deseas importar.",
    newOrders: "Importar CSV de ventas",
    newClients: "Importar CSV de clientes",
    backfillButton: "Importar historial {0}",
    backfillTitle: "Importar historial",
    backfillSubtitle: "Elige el período de los pedidos que deseas importar de la integración.",
    backfillStart: "Iniciar importación",
    backfillStarted: "¡Importación de historial iniciada! Se procesará en segundo plano.",
    backfillError: "No se pudo iniciar la importación de historial.",
    queuedNotice: "¡Importación enviada! Se procesará en segundo plano.",
};
